import { createStyles, rem } from '@mantine/core';
var useStyles = createStyles(function (theme) {
  return {
    root: {
      position: "relative",
      border: "".concat(rem(1), " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]),
      borderRadius: theme.fn.radius()
    }
  };
});
export default useStyles;